import {createFileRoute} from '@tanstack/react-router'

import {zeroLevelIndexRoute} from "../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/cwg-collection/browse/')({
    ...zeroLevelIndexRoute("/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName")
});
